import { useEffect, useState, useContext } from "react";
import { createContext } from "react";
import { useAuth } from "./AuthProvider";
import { getQuotesNotifications } from "../helpers/http_quotes_requests ";

export const PendingQuotesContext = createContext({});

export function PendingQuotesProvider({ children }) {
    const [totalQuotes, setTotalQuotes] = useState(0);

    const { id } = useAuth();

    async function refreshQuotesNotifications() {

        const response = await getQuotesNotifications();

        const responseTotalQuotes = response.data.data.total_pending;

        setTotalQuotes(responseTotalQuotes);

    };

    useEffect(() => {

        if (Boolean(id)) {

            refreshQuotesNotifications();

        };

    }, [id]);


    const value = {
        totalQuotes: totalQuotes,
        refreshQuotesNotifications
    };

    return (
        <PendingQuotesContext.Provider value={value} >
            {children}
        </PendingQuotesContext.Provider>
    );
}

export function usePendingQuotes() {
    return useContext(PendingQuotesContext);
};
